import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.mentalCheckRequests.loading;
export const selectErrorMessage = (state: RootState) =>
  state.mentalCheckRequests.error;
export const mentalCheckRequestsDataResponse = (state: RootState) =>
  state.mentalCheckRequests.mentalCheckRequestsResponse;
